import React from 'react'

import { i18n } from '~/i18n'
import fullName from '~/utils/full-name'

import {
  TitleContainer,
  Name,
  CreditsRemaining,
  Container,
} from './profile-credits-summary.styles'
import CreditSummary from '../credit-summary'

import type { ProfileWithCredits } from '../profiles-credits-summary.types'

type Props = {
  disableCreditDetailsBackground?: boolean
  onReset?: (arg0: number) => Promise<void>
  profileWithCredits: ProfileWithCredits
}

export default function ProfileCreditsSummary({
  profileWithCredits,
  disableCreditDetailsBackground,
  onReset,
}: Props) {
  const creditsRemaining = profileWithCredits.credits.filter(
    (credit) => credit.status === 'active',
  ).length

  return (
    <Container>
      <TitleContainer>
        <Name>
          {fullName(profileWithCredits.firstName, profileWithCredits.lastName)}
        </Name>
        <CreditsRemaining>
          {i18n.t(
            'components.profiles_credits_summary.profile_credits_summary.credits_remaining',
            {
              creditsRemaining: creditsRemaining.toString(),
              count: profileWithCredits.credits.length,
            },
          )}
        </CreditsRemaining>
      </TitleContainer>
      {profileWithCredits.credits.map((credit) => (
        <CreditSummary
          key={credit.id}
          credit={credit}
          disableCreditDetailsBackground={disableCreditDetailsBackground}
          onReset={onReset}
        />
      ))}
    </Container>
  )
}
